import { SuccessResult } from "../model/connect";
import { UserInfo } from "~/app/core/model/user-info";
import { UserAuthType } from "~/app/core/model/user-auth-type";
import { UserLoginResult } from "~/app/core/model/user-login-result";
import { toDateStr } from "~/app/core/model/date-str";
import { StorageService } from "~/app/core/storage.service";
import { InitInfo } from "~/app/core/model/init-info";
import { InterfaceUserProfileService } from "~/app/core/user-profile-service/interface-user-profile-service";
import * as Log from "~/app/core/log";
import { SettingsService } from "~/app/core/settings.service";
import { Settings } from "~/app/core/model/settings";
import { UserProperty } from "~/app/core/model/user-property";
import { DeviceSpecs } from "~/app/core/model/rpc/device-specs";

export class SampleUserProfileService implements InterfaceUserProfileService {
    constructor(
        private readonly settingsService: SettingsService,
        private readonly storageService: StorageService
    ) {
    }

    initService() {
        const userInfo = this.storageService.loadUserInfo(this.settings.env);
        if (!userInfo) {
            this.storageService.storeUserInfo({
                authToken: "testauth",
                firstName: "Test",
                lastName: "User",
                needsValidation: false,
                email: "test@test.com",
                auth: UserAuthType.WhutsFree,
                photoUrl: null,
                id: null
            }, this.settings.env);
        }
    }

    setReferralCode(referralCode: string) {
      this.storageService.storeCode(referralCode);
    }
    getReferralCode(): string {
      return this.storageService.loadCode();
    }

  getUserReferralCode(): Promise<string> {
    return Promise.resolve('hello');
  }

    get userInfo(): UserInfo {
        return this.storageService.loadUserInfo(this.settings.env);
    }

    get deviceInfo(): InitInfo {
        return this.storageService.loadInitInfo();
    }

    private get settings(): Settings {
        return this.settingsService.loadSettings();
    }

    setWelcomed() {
        const initInfo = this.deviceInfo;
        initInfo.needWelcome = false;
        this.storageService.storeInitInfo(initInfo);
    }

    isWelcomed(): boolean {
        const initInfo = this.deviceInfo;
        return initInfo && initInfo.needWelcome !== true;
    }

    captureLocation(): Promise<void> {
        // do nothing;
        return Promise.resolve();
    }

    updateUserProperty(property: UserProperty, value: string): Promise<void> {
        return Promise.resolve();
    }

    testResetWelcomed(): void {
        this.storageService.storeInitInfo(null);
    }

    testResetFirstRedeem(): void {
        const userInfo: UserInfo = this.storageService.loadUserInfo(this.settings.env);
        userInfo.firstRedeemDate = null;
        this.storageService.storeUserInfo(userInfo, this.settings.env);
    }

    showRegister(): void {
        const initInfo = this.deviceInfo;
        if (initInfo) {
            initInfo.showLogin = false;
            this.storageService.storeInitInfo(initInfo);
        }
    }

    testDeleteUser(): Promise<SuccessResult> {
        this.showRegister();
        this.testResetWelcomed();
        this.testResetFirstRedeem();
        this.logout();
        return Promise.resolve({
            success: true
        });
    }

    isAuthenticated(): boolean {
        const userInfo = this.userInfo;
        return userInfo && userInfo.authToken != null;
    }

    needsValidation(): boolean {
        const userInfo = this.userInfo;
        return userInfo && userInfo.needsValidation;
    }

    initDevice(deviceSpecs: DeviceSpecs): Promise<InitInfo> {
        const initInfo = this.storageService.loadInitInfo();
        if (!initInfo) {
            this.storageService.storeInitInfo({
                showLogin: false,
                needWelcome: true
            });
        }
        return Promise.resolve(this.storageService.loadInitInfo());
    }

    loginWithFacebook(pushToken: string): Promise<UserLoginResult> {
        return new Promise((resolve, reject) => {
            // SocialLogin.loginWithFacebook((result) => {
            //     Log.trace(Log.Tag.SampleUserProfileService, result);
            //     if (result.authToken) {
            //         this.storageService.storeUserInfo({
            //             auth: UserAuthType.Facebook,
            //             authToken: "testauth",
            //             id: null,
            //             needsValidation: false,
            //             firstName: result.firstName,
            //             lastName: result.lastName,
            //             email: result.userToken,
            //             photoUrl: result.photo
            //         }, this.settings.env);
            //         resolve({
            //             success: true,
            //             validated: true
            //         });
            //     } else {
                    resolve({
                        success: false,
                        validated: false
                    });
            //     }
            // });
        });
    }

    loginWithGoogle(pushToken: string): Promise<UserLoginResult> {
        return new Promise((resolve, reject) => {
            // SocialLogin.loginWithGoogle((result) => {
            //     Log.trace(Log.Tag.SampleUserProfileService, result);
            //     if (result.code === 0 && result.id) {
            //         this.storageService.storeUserInfo({
            //             auth: UserAuthType.Google,
            //             authToken: "testauth",
            //             id: Number(result.id),
            //             needsValidation: false,
            //             firstName: result.firstName,
            //             lastName: result.lastName,
            //             email: result.userToken,
            //             photoUrl: result.photo
            //         }, this.settings.env);
            //         resolve({
            //             success: true,
            //             validated: true
            //         });
            //     } else {
                    resolve({
                        success: false,
                        validated: false
                    });
            //     }
            // });
        });
    }

    loginWithApple(pushToken: string): Promise<UserLoginResult> {
        return new Promise((resolve, reject) => {
            // signInWithApple({ scopes: ["EMAIL", "FULLNAME"] }).then((credential) => {
            //     Log.debug(Log.Tag.SampleUserProfileService, "Signed in, user: " + credential.user);
            //     Log.debug(Log.Tag.SampleUserProfileService, credential);
            //     if (credential.user) {
            //         this.storageService.storeUserInfo({
            //             auth: UserAuthType.Google,
            //             authToken: credential.identityToken,
            //             id: 1,
            //             needsValidation: false,
            //             firstName: "First",
            //             lastName: "Last",
            //             email: "email@email.com",
            //             photoUrl: null
            //         }, this.settings.env);
            //         resolve({
            //             success: true,
            //             validated: true
            //         });
            //     } else {
                    resolve({
                        success: false,
                        validated: false
                    });
            //     }
            // })
            // .catch((err) => {
            //     Log.debug(Log.Tag.SampleUserProfileService, "Error signing in: " + err);
            //     resolve({
            //         success: false,
            //         validated: false
            //     });
            // });
        });
    }

    forgotPassword(email: string): Promise<SuccessResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({success: true});
            }, 500);
        });
    }

    resetPassword(email: string, code: string, newPassword: string): Promise<UserLoginResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (code !== "123456") {
                    resolve({success: false, validated: false});
                } else {
                    this.storageService.storeUserInfo({
                        auth: UserAuthType.WhutsFree,
                        authToken: "testauth",
                        id: 1,
                        needsValidation: false,
                        firstName: "Test",
                        lastName: "Reset",
                        email: email,
                        photoUrl: null
                    }, this.settings.env);
                    resolve({success: true, validated: true});
                }
            }, 500);
        });
    }

    register(firstName: string, lastName: string, email: string, password: string, pushToken: string): Promise<UserLoginResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.storageService.storeUserInfo({
                    auth: UserAuthType.WhutsFree,
                    authToken: "testauth",
                    id: null,
                    needsValidation: password !== "password",
                    firstName,
                    lastName,
                    email,
                    photoUrl: null
                }, this.settings.env);
                resolve({
                    success: true,
                    validated: false
                });
            }, 1500);
        });
    }

    resendValidationCode(email: string): Promise<SuccessResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({
                    success: true
                });
            }, 1500);
        });
    }

    login(email: string, password: string, pushToken: string): Promise<UserLoginResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (password !== "password" && password !== "invalid") {
                    resolve({
                        success: false,
                        validated: false
                    });
                } else {
                    this.storageService.storeUserInfo({
                        auth: UserAuthType.WhutsFree,
                        authToken: "testauth",
                        id: null,
                        needsValidation: password !== "password",
                        firstName: "Jimmy",
                        lastName: "Jackson",
                        email,
                        photoUrl: null
                    }, this.settings.env);
                    this.initUserInfo().then((info) => {
                        resolve({
                            success: true,
                            validated: !this.needsValidation()
                        });
                    }, (error) => {
                        reject(error);
                    });
                }
            }, 500);
        });
    }

    validate(validationCode: string): Promise<SuccessResult> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (Log.isTrace(Log.Tag.SampleUserProfileService)) {
                    Log.trace(Log.Tag.SampleUserProfileService, "validationCode: " + (validationCode === "123456"));
                }
                if (!this.isAuthenticated() || validationCode !== "123456") {
                    resolve({success: false});
                } else {
                    const userInfo: UserInfo = this.storageService.loadUserInfo(this.settings.env);
                    userInfo.needsValidation = false;
                    this.storageService.storeUserInfo(userInfo, this.settings.env);
                    resolve({success: true});
                }
            }, 500);
        });
    }

    abortValidation(): void {
        this.storageService.storeUserInfo(null, this.settings.env);
    }

    logout(): void {
        // SocialLogin.logout(() => {
        //     // logout
        // });
        this.storageService.storeUserInfo(null, this.settings.env);
    }

    setFirstRedemption(): UserInfo {
        const userInfo: UserInfo = this.storageService.loadUserInfo(this.settings.env);
        if (!userInfo.firstRedeemDate) {
            userInfo.firstRedeemDate = toDateStr(this.settings.calculateCurrentTime());
        }
        this.storageService.storeUserInfo(userInfo, this.settings.env);
        return userInfo;
    }

    contactUs(reason: "support"|"merchants"|"sponsors", firstName: string, lastName: string, email: string, content: string): Promise<SuccessResult> {
        return Promise.resolve({
            success: true
        });
    }

    // private getDeviceId(): string {
    //     return uuidPlugin.getUUID();
    // }

    private initUserInfo(): Promise<UserInfo> {
        const userInfo: UserInfo = this.storageService.loadUserInfo(this.settings.env);
        if (userInfo && userInfo.authToken) {
            userInfo.firstName = "Test";
            userInfo.lastName = "User";
            this.storageService.storeUserInfo(userInfo, this.settings.env);
        }
        return Promise.resolve(userInfo);
    }
}
